var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.$store.state.leaderboard)?_c('div',{staticClass:"leaderboard__wrapper",class:_vm.wrapperClass,style:(_vm.wrapperStyle)},_vm._l((_vm.activeRound.groups),function(group){return _c('div',{key:group.id},[_c('leaderboard-group',{attrs:{"value":group,"is-single":""}})],1)}),0):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }